<template>
    <div class="section" :class="main_color">
      <div class="page-content">
        <div class="part">
          <div class="lexique">
            <p class="label main_color_text" style="margin: 10px 0 0 0">
              Annexe
            </p>
            <div class="titre-1" style="margin: 0 0 6px 0">
              Carte de localisation
            </div>
            <div class="mapComponent" :class="{no_edit: editor.mode != 'editing'}" :style="{'z-index': editor.mode == 'editing' ? 10001 : 0}">
              <MapComponent height="480" allow_annotations linkedToView ref="bigMap"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import MapComponent from "../../elements/MapComponent.vue";
  
export default {
	name: "section-lexique2",
	mixins: [PageMixin],
	components: { MapComponent },
    
	props: {
		main_color: { default: "gray" },
	},
	data: function () {
		return {
		};
	},
	computed: {
		...mapGetters(["active_study", "editor"]),
	},
	mounted () {
		this.$root.$on("scrollToBigMapLLI", () => this.$refs.bigMap.$el.scrollIntoView({ behavior: "smooth" }));
	},
};
</script>
  
  <style lang="stylus" scoped>
  @import '../../../../../assets/css/app';
  @import '../../../../../assets/css/page';
  @import '../../../../../assets/css/lexique';
  </style>
  